export const initialState = {
  filter: [],
  inactiveFilter: [],
  selectedSportId: null
};
